/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import styled from "styled-components";
import { Box, Spacer, Text, theme } from "@nordcloud/gnui";
import { ChangeDetails as changeDetailsTypes } from "~/generated/graphql";
import { dateFormat } from "~/constants";

type Props = {
  details?: changeDetailsTypes;
  removeBorderBottomRadius?: boolean;
};

export function ChangeDetails({
  details,
  removeBorderBottomRadius = false,
}: Props) {
  return (
    <StyledBox
      removeBorderBottomRadius={removeBorderBottomRadius}
      boxStyle="lightGrey"
    >
      <Text tag="div" size="sm" color={theme.color.text.text02}>
        Added by
      </Text>
      <Text tag="div">{details?.createdBy ?? "Unknown"}</Text>
      <Text tag="div" size="sm" color={theme.color.text.text02}>
        {details?.createdAt
          ? dayjs(details.createdAt).format(dateFormat.dayMonthYearHourMinute)
          : "-"}
      </Text>
      <Spacer height={theme.spacing.spacing04} />
      <Text tag="div" size="sm" color={theme.color.text.text02}>
        Updated by
      </Text>
      <Text tag="div">{details?.updatedBy ?? "Unknown"}</Text>
      <Text tag="div" size="sm" color={theme.color.text.text02}>
        {details?.updatedAt
          ? dayjs(details.updatedAt).format(dateFormat.dayMonthYearHourMinute)
          : "-"}
      </Text>
    </StyledBox>
  );
}

const StyledBox = styled(Box)<{ removeBorderBottomRadius: boolean }>`
  flex: 1;
  border-bottom-left-radius: ${({ removeBorderBottomRadius }) =>
    removeBorderBottomRadius && 0};
  border-bottom-right-radius: ${({ removeBorderBottomRadius }) =>
    removeBorderBottomRadius && 0};
`;
